import { Component, ViewChild } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { ModalDirective, ModalModule } from 'ngx-bootstrap/modal';
import { ApiMissionsService } from '../../../../services/missions/api/api-missions.service';
import { AlertsService } from '../../../../services/alerts.service';
import { MissionType } from '../../../../enums/missions/mission-type.enum';

@Component({
  selector: 'app-mission-add-modal',
  templateUrl: './mission-add-modal.component.html',
  standalone: true,
  imports: [ModalModule, CommonModule, FormsModule]
})
export class MissionAddModalComponent {

  @ViewChild('modal') modal!: ModalDirective;

  isLoading: boolean = false;
  type: number = 0;
  startDate: string = '';
  endDate: string = '';
  completeQuantity: number = 0;
  pointsReward: number = 0;
  customParam: number = 0;

  readonly missionTypes = Object.entries(MissionType).filter(([, v]) => typeof v === 'number') as [string, number][];

  private callbackSaved?: () => void;

  constructor(private apiMissionsService: ApiMissionsService, private alertsService: AlertsService) {}

  show(callbackSaved?: () => void): void {
    this.callbackSaved = callbackSaved;
    this.type = 0;
    this.startDate = '';
    this.endDate = '';
    this.completeQuantity = 0;
    this.pointsReward = 0;
    this.customParam = 0;
    this.isLoading = false;
    this.modal.show();
  }

  save(): void {
    this.isLoading = true;
    const startTimestamp = this.startDate ? Math.floor(new Date(this.startDate + 'Z').getTime() / 1000) : 0;
    const endTimestamp = this.endDate ? Math.floor(new Date(this.endDate + 'Z').getTime() / 1000) : 0;
    this.apiMissionsService.addMission(this.type, startTimestamp, endTimestamp, this.completeQuantity, this.pointsReward, this.customParam).then(
      () => {
        this.isLoading = false;
        this.modal.hide();
        this.alertsService.displayAlertSuccess('Mission added !');
        if (this.callbackSaved) { this.callbackSaved(); }
      }, error => {
        this.isLoading = false;
        this.alertsService.displayAlertError('Error adding mission : ' + error);
      }
    );
  }
}
